// Passive production tick. Pours building output and auto-collection into the
// resource pool each simulation step and credits the run's age progress. The
// rates themselves come from stats.computeIncome so the HUD and the sim never
// disagree.

import type { GameState } from '@core/state';
import { RESOURCE_ORDER, type ResourceId } from '@data/resources';
import { computeIncome, progressValue } from './stats';

export function updateProduction(state: GameState, dt: number): void {
  const income = computeIncome(state);
  const gained: Partial<Record<ResourceId, number>> = {};
  for (const id of RESOURCE_ORDER) {
    const g = income[id] * dt;
    if (g !== 0) {
      state.run.resources[id] += g;
      gained[id] = g;
    }
  }
  state.run.progress += progressValue(gained);
}
